import { Capacitor } from '@capacitor/core';

/** Whether the app runs inside the iOS or Android shell rather than a browser. */
export const isNative: boolean = Capacitor.isNativePlatform();

/** 'ios', 'android' or 'web'. */
export const platform: string = Capacitor.getPlatform();
